import { haptics } from '../../lib/haptics'

interface Props {
  label: string
  active: boolean
  onClick: () => void
  variant?: 'default' | 'secure'
}

export default function CategoryChip({ label, active, onClick, variant = 'default' }: Props) {
  return (
    <button
      onClick={() => {
        haptics.selection()
        onClick()
      }}
      className="px-sp-3 py-1.5 rounded-full text-[13px] font-medium transition-all shrink-0 active:opacity-70"
      style={
        active
          ? variant === 'secure'
            ? {
                background: 'linear-gradient(110deg, #A062FF 0%, #3088FF 30%, #61D8FF 60%, #A062FF 85%, #3088FF 100%)',
                backgroundSize: '200% 100%',
                animation: 'cocoon-flow 3s ease-in-out infinite',
                color: '#ffffff',
              }
            : { backgroundColor: 'var(--tg-theme-button-color)', color: 'var(--tg-theme-button-text-color)' }
          : {
              backgroundColor: 'var(--tg-theme-secondary-bg-color)',
              color: 'var(--tg-theme-hint-color)',
            }
      }
    >
      {label}
    </button>
  )
}
